import { assert_number_gte_0, assert_string_not_empty, assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestViewerAction extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_VIEWER_ACTION;

  viewer_id!: string;
  workspace_id!: string;
  current_viewed_entity_id!: string;

  component_id!: string;
  entity_type!: string;

  created_at!: number;

  /*
   * METHODS
   */
  constructor(component_id: string = '') {
    super();

    this.component_id = component_id;
    this.entity_type = '';
  }

  assert_standard_fields(): void {
    assert_string_object_id(this.viewer_id);
    assert_string_object_id(this.workspace_id);
    assert_string_object_id(this.current_viewed_entity_id);

    assert_string_not_empty(this.component_id);

    assert_number_gte_0(this.created_at);
  }
}
